import { useDispatch } from 'react-redux';
import { Card, Typography } from 'components';
import { CardErrorBoundaryWithSpinfinity } from 'components/Card/CardErrorBoundaryWithSpinfinity';
import { removeModalOpened } from 'store/modal';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

import { Icon } from '@repo/ui';

import replayIllustration from 'assets/images/summary/first-look/replay_illustration.svg';
import styles from './ReplayFirstLookCard.module.scss';

const ReplayFirstLookCardContent = () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();

  const handleReplay = () => {
    trackEvent('First Look', {
      event_type: 'replay_button_clicked',
      button_text: 'Replay your First Look',
      location: 'summary_card',
    });
    const modalIdentifier = {
      name: 'firstLook',
      props: {},
    };
    dispatch(removeModalOpened(modalIdentifier));
  };

  return (
    <Card className={styles.card} onClick={handleReplay}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <Icon name='playFilled' size='s' className={styles.playIcon} />
        </div>
        <Typography variant='heading-s' className={styles.text}>
          Replay your First Look
        </Typography>
      </div>
      <img
        src={replayIllustration}
        alt='Replay First Look'
        className={styles.illustration}
      />
    </Card>
  );
};

export const ReplayFirstLookCard = () => {
  return (
    <CardErrorBoundaryWithSpinfinity cardName='ReplayFirstLookCard'>
      <ReplayFirstLookCardContent />
    </CardErrorBoundaryWithSpinfinity>
  );
};
